import React, { useState, useMemo, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import {
  useGetLicensesQuery,
  useGetGymByIdQuery,
  useAssignLicensesMutation,
  useUnAssignLicenseMutation,

} from "../../services";
import { LicensesType } from "../../types/subscription/subscriptionScreen/subscriptionScreen.type";
import { adminRoutes } from "../../routers/AdminRouters";
import { useAppSelector } from "../../redux/hooks";
import { RootState } from "../../redux/store";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { toast } from "react-hot-toast";
import ConfirmActionModal from "../subscription/licenses/screenModal/ConfirmActionModal";
import { selectOrganisationId } from "../../redux/organisationReducer";

const ItemTypes = {
  LICENSE: "license",
};

const LicenseIcon: React.FC<{ type: string }> = ({ type }) => {
  if (type === "PREMIUM") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12.75"
          cy="12.75"
          r="10.75"
          fill="url(#paint0_radial_3497_13606)"
        />
        <g filter="url(#filter0_n_3497_13606)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.75 2C6.81294 2 2 6.81294 2 12.75C2 18.687 6.81293 23.5 12.75 23.5C18.687 23.5 23.5 18.687 23.5 12.75C23.5 6.81293 18.687 2 12.75 2ZM13.9312 7.69832C13.4315 6.76723 12.0677 6.76722 11.568 7.69832L10.332 10.0014L7.63056 10.4099C6.59836 10.566 6.07502 11.8457 6.90365 12.6346L8.81505 14.4546L8.39536 16.9848C8.20793 18.1148 9.40827 18.7971 10.3045 18.3635L12.7496 17.1807L15.1947 18.3635C16.0909 18.7971 17.2913 18.1148 17.1038 16.9848L16.6841 14.4546L18.5955 12.6346C19.4242 11.8457 18.9008 10.566 17.8686 10.4099L15.1671 10.0014L13.9312 7.69832Z"
            fill="url(#paint1_linear_3497_13606)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.75 2C6.81294 2 2 6.81294 2 12.75C2 18.687 6.81293 23.5 12.75 23.5C18.687 23.5 23.5 18.687 23.5 12.75C23.5 6.81293 18.687 2 12.75 2ZM13.9312 7.69832C13.4315 6.76723 12.0677 6.76722 11.568 7.69832L10.332 10.0014L7.63056 10.4099C6.59836 10.566 6.07502 11.8457 6.90365 12.6346L8.81505 14.4546L8.39536 16.9848C8.20793 18.1148 9.40827 18.7971 10.3045 18.3635L12.7496 17.1807L15.1947 18.3635C16.0909 18.7971 17.2913 18.1148 17.1038 16.9848L16.6841 14.4546L18.5955 12.6346C19.4242 11.8457 18.9008 10.566 17.8686 10.4099L15.1671 10.0014L13.9312 7.69832Z"
            fill="#C6D92C"
            fillOpacity="0.1"
          />
        </g>
        <circle
          cx="12.75"
          cy="12.75"
          r="10.25"
          stroke="url(#paint2_linear_3497_13606)"
          strokeOpacity="0.88"
        />
        <path
          d="M11.2939 7.81641C11.6993 7.06107 12.8114 7.06112 13.2168 7.81641L14.4531 10.1191L14.5117 10.2295L14.6357 10.249L17.3369 10.6572C18.1918 10.7865 18.5864 11.8269 17.9287 12.4531L16.0176 14.2734L15.9219 14.3652L15.9434 14.4951L16.3633 17.0254C16.4394 17.4839 16.238 17.8433 15.9238 18.0518C15.6023 18.2649 15.1713 18.3136 14.8096 18.1387L12.3643 16.9561L12.2559 16.9033L12.1465 16.9561L9.70117 18.1387C9.33945 18.3135 8.90938 18.2648 8.58789 18.0518C8.27342 17.8433 8.07137 17.4841 8.14746 17.0254L8.56738 14.4951L8.58887 14.3652L8.49316 14.2734L6.58203 12.4531C5.92445 11.8269 6.31904 10.7865 7.17383 10.6572L9.875 10.249L9.99902 10.2295L10.0586 10.1191L11.2939 7.81641Z"
          stroke="url(#paint3_linear_3497_13606)"
          strokeOpacity="0.88"
          strokeWidth="0.5"
        />
        <defs>
          <filter
            id="filter0_n_3497_13606"
            x="2"
            y="2"
            width="21.5"
            height="21.5"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feTurbulence
              type="fractalNoise"
              baseFrequency="2 2"
              stitchTiles="stitch"
              numOctaves="3"
              result="noise"
              seed="2744"
            />
            <feColorMatrix
              in="noise"
              type="luminanceToAlpha"
              result="alphaNoise"
            />
            <feComponentTransfer in="alphaNoise" result="coloredNoise1">
              <feFuncA
                type="discrete"
                tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
              />
            </feComponentTransfer>
            <feComposite
              operator="in"
              in2="shape"
              in="coloredNoise1"
              result="noise1Clipped"
            />
            <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
            <feComposite
              operator="in"
              in2="noise1Clipped"
              in="color1Flood"
              result="color1"
            />
            <feMerge result="effect1_noise_3497_13606">
              <feMergeNode in="shape" />
              <feMergeNode in="color1" />
            </feMerge>
          </filter>
          <radialGradient
            id="paint0_radial_3497_13606"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(10.5 10) rotate(54.7824) scale(10.4043)"
          >
            <stop stopColor="#D1E156" />
            <stop offset="0.552885" stopColor="#C6D92C" />
            <stop offset="1" stopColor="#7A8618" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_3497_13606"
            x1="12.75"
            y1="3"
            x2="12.75"
            y2="22.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2E2E2E" />
            <stop offset="1" stopColor="#666666" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3497_13606"
            x1="2"
            y1="12.75"
            x2="23.5"
            y2="12.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C6D92C" />
            <stop offset="0.533654" stopColor="#EDF5C0" />
            <stop offset="1" stopColor="#C6D92C" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3497_13606"
            x1="6"
            y1="12.7476"
            x2="18.5109"
            y2="12.7476"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C6D92C" />
            <stop offset="0.533654" stopColor="#EDF5C0" />
            <stop offset="1" stopColor="#C6D92C" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g filter="url(#filter0_n_3497_13593)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.75 2C6.81294 2 2 6.81294 2 12.75C2 18.687 6.81293 23.5 12.75 23.5C18.687 23.5 23.5 18.687 23.5 12.75C23.5 6.81293 18.687 2 12.75 2Z"
          fill="url(#paint0_linear_3497_13593)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.75 2C6.81294 2 2 6.81294 2 12.75C2 18.687 6.81293 23.5 12.75 23.5C18.687 23.5 23.5 18.687 23.5 12.75C23.5 6.81293 18.687 2 12.75 2Z"
          fill="#C6D92C"
          fillOpacity="0.1"
        />
      </g>
      <circle
        cx="12.75"
        cy="12.75"
        r="10.25"
        stroke="url(#paint1_linear_3497_13593)"
        strokeOpacity="0.88"
      />
      <defs>
        <filter
          id="filter0_n_3497_13593"
          x="2"
          y="2"
          width="21.5"
          height="21.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="2 2"
            stitchTiles="stitch"
            numOctaves="3"
            result="noise"
            seed="2744"
          />
          <feColorMatrix
            in="noise"
            type="luminanceToAlpha"
            result="alphaNoise"
          />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA
              type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="shape"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
          <feComposite
            operator="in"
            in2="noise1Clipped"
            in="color1Flood"
            result="color1"
          />
          <feMerge result="effect1_noise_3497_13593">
            <feMergeNode in="shape" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <linearGradient
          id="paint0_linear_3497_13593"
          x1="12.75"
          y1="3"
          x2="12.75"
          y2="22.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2E2E2E" />
          <stop offset="1" stopColor="#666666" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3497_13593"
          x1="2"
          y1="12.75"
          x2="23.5"
          y2="12.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6D92C" />
          <stop offset="0.533654" stopColor="#EDF5C0" />
          <stop offset="1" stopColor="#C6D92C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DraggableLicense: React.FC<{
  license: any;
  isDark: boolean;
  isSelected: boolean;
  toggleLicenseSelection: (l: any) => void;
}> = ({ license, isDark, isSelected, toggleLicenseSelection }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.LICENSE,
    item: { license },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      onClick={() => toggleLicenseSelection(license)}
      className={`p-4 rounded-2xl border cursor-pointer transition-all duration-200 flex items-center justify-between ${isSelected
        ? "border-[#2A2A2A] bg-white/5 shadow-lg"
        : isDark
          ? "border-[#1F1F1F] bg-transparent hover:border-gray-700"
          : "border-gray-200 bg-white hover:border-gray-300"
        } ${isDragging ? "opacity-40 scale-95" : "opacity-100 scale-100"}`}
    >
      <div className="flex items-center gap-3 flex-1">
        <div>
          <LicenseIcon type={license.type} />
        </div>
        <div className="flex items-center gap-4 flex-1">
          <div
            className={`font-bold text-sm ${isDark ? "text-white" : "text-gray-900"
              }`}
          >
            {license.type.charAt(0) + license.type.slice(1).toLowerCase()}
          </div>
          <div className="text-[12px] text-gray-400">
            License ID:{" "}
            <span className="font-mono text-[#D9FB51] font-bold">
              #{license.code || license._id.slice(-6)}
            </span>
          </div>
        </div>
      </div>
      <div className="text-[11px] font-bold text-right ml-4">
        <span className="text-[#D9FB51]">{license.screens?.length || 0}</span>
        <span
          className={`${isDark ? "text-gray-400" : "text-gray-500"
            } ml-1 mr-3 font-medium`}
        >
          Screens +
        </span>
        <span className="text-[#D9FB51]">
          {license.addOnScreens?.length || 0}
        </span>
        <span
          className={`${isDark ? "text-gray-400" : "text-gray-500"
            } ml-1 font-medium`}
        >
          Addons
        </span>
      </div>

    </div>
  );
};

const LICENSE_PAGE_SIZE = 10;

const GymLicenseSelectionContent: React.FC = () => {
  const { gymid } = useParams<{ gymid: string }>();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const isDark = theme === "dark";
  const organisationId = useAppSelector(selectOrganisationId);

  // Available Licenses State
  const [availablePage, setAvailablePage] = useState(1);
  const [availableLicenses, setAvailableLicenses] = useState<any[]>([]);
  const [hasMoreAvailable, setHasMoreAvailable] = useState(true);

  // Assigned Licenses State
  const [assignedPage, setAssignedPage] = useState(1);
  const [assignedLicenses, setAssignedLicenses] = useState<any[]>([]);
  const [hasMoreAssigned, setHasMoreAssigned] = useState(true);

  // Queries
  const {
    data: availableResp,
    isLoading: isAvailableLoading,
    isFetching: isAvailableFetching,
  } = useGetLicensesQuery(
    { organisationId, page: availablePage, limit: LICENSE_PAGE_SIZE, isAssigned: false },
    { skip: !organisationId }
  );

  const {
    data: assignedResp,
    isLoading: isAssignedLoading,
    isFetching: isAssignedFetching,
  } = useGetLicensesQuery(
    { organisationId, page: assignedPage, limit: LICENSE_PAGE_SIZE, gymId: gymid, isAssigned: true },
    { skip: !organisationId || !gymid }
  );

  const { data: gymResp, isLoading: isGymLoading } = useGetGymByIdQuery(
    gymid as string,
    { skip: !gymid }
  );
  const [licenseType, setLicenseType] = useState<string>("All Licenses");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [licenseToChange, setLicenseToChange] = useState<{
    licenseId: string;
    status: "Active" | "Inactive";
  } | null>(null);

  const [assignLicenses, { isLoading: isAssigning }] =
    useAssignLicensesMutation();
  const [unAssignLicenses, { isLoading: isUnAssigning }] =
    useUnAssignLicenseMutation();

  // Handle Available Resp
  useEffect(() => {
    if (!availableResp?.results) return;

    setAvailableLicenses((prev) => {
      if (availablePage === 1) return availableResp.results;
      const existingIds = new Set(prev.map((l: any) => l._id));
      const newOnes = availableResp.results.filter((l: any) => !existingIds.has(l._id));
      return [...prev, ...newOnes];
    });

    setHasMoreAvailable(availableResp.results.length >= LICENSE_PAGE_SIZE);
  }, [availableResp, availablePage]);

  // Handle Assigned Resp
  useEffect(() => {
    if (!assignedResp?.results) return;

    setAssignedLicenses((prev) => {
      if (assignedPage === 1) return assignedResp.results;
      const existingIds = new Set(prev.map((l: any) => l._id));
      const newOnes = assignedResp.results.filter((l: any) => !existingIds.has(l._id));
      return [...prev, ...newOnes];
    });

    setHasMoreAssigned(assignedResp.results.length >= LICENSE_PAGE_SIZE);
  }, [assignedResp, assignedPage]);

  // Combined selected list (Assigned + Local New Selections)
  // We'll use a local state to track which licenses were PICKED during this session
  const [newlySelectedLicenses, setNewlySelectedLicenses] = useState<any[]>([]);

  const selectedLicenses = useMemo(() => {
    return [...assignedLicenses, ...newlySelectedLicenses];
  }, [assignedLicenses, newlySelectedLicenses]);

  const handleAssign = async () => {
    const newlySelectedIds = newlySelectedLicenses.map((l: any) => l._id);

    if (newlySelectedIds.length === 0) {
      navigate(adminRoutes.gymList);
      return;
    }

    try {
      await assignLicenses({
        gymid: gymid!,
        licenses: newlySelectedIds,
      }).unwrap();
      toast.success("Licenses assigned successfully");
      navigate(adminRoutes.gymList);
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to assign licenses");
    }
  };

  const handleStatusChangeClick = (
    licenseId: string,
    currentStatus: string
  ) => {
    const newStatus: "Active" | "Inactive" =
      currentStatus === "Active" ? "Inactive" : "Active";
    setLicenseToChange({ licenseId, status: newStatus });
    setConfirmModalOpen(true);
  };

  const handleConfirmStatusChange = async () => {
    if (!licenseToChange || !gymid) return;

    try {
      await unAssignLicenses({
        licenseId: licenseToChange.licenseId,
      }).unwrap();

      // Remove the unassigned license from state
      setAssignedLicenses((prev) =>
        prev.filter((l) => l._id !== licenseToChange.licenseId)
      );
      setNewlySelectedLicenses((prev) =>
        prev.filter((l) => l._id !== licenseToChange.licenseId)
      );

      // Reset to page 1 to force a fresh fetch
      setAssignedPage(1);
      setAvailablePage(1);

      toast.success(`License status changed to ${licenseToChange.status}`);
      setConfirmModalOpen(false);
      setLicenseToChange(null);
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to change license status");
    }
  };

  const gymOrgId = useMemo(() => {
    if (!gymResp) return null;
    const org = gymResp.organisation;
    return typeof org === "string" ? org : org?._id;
  }, [gymResp]);

  const isEditMode = useMemo(() => {
    return assignedLicenses.length > 0;
  }, [assignedLicenses]);

  const filteredLicenses = useMemo(() => {
    return availableLicenses.filter((l: any) => {
      // Type filter
      const matchesType =
        licenseType === "All Licenses" ? true :
          licenseType === "Basic License" ? l.type === LicensesType.BASIC :
            l.type === LicensesType.PREMIUM;

      const matchesOrg =
        !gymOrgId ||
        (typeof l.organisation === "string"
          ? l.organisation === gymOrgId
          : l.organisation?._id === gymOrgId);

      // Not already in the selected list
      const notAlreadyInSelected = !selectedLicenses.some((s) => s._id === l._id);

      return matchesType && matchesOrg && notAlreadyInSelected;
    });
  }, [availableLicenses, licenseType, gymOrgId, selectedLicenses]);

  const hasLicensesForOrg = useMemo(() => {
    return availableLicenses.length > 0 || assignedLicenses.length > 0;
  }, [availableLicenses, assignedLicenses]);

  const noLicensesForOrg =
    !!gymOrgId && !hasLicensesForOrg && !isAvailableLoading && !isAssignedLoading && !isGymLoading;

  const toggleLicenseSelection = (license: any) => {
    setNewlySelectedLicenses((prev) => {
      const isSelected = prev.find((l) => l._id === license._id);
      if (isSelected) {
        return prev.filter((l) => l._id !== license._id);
      } else {
        return [...prev, license];
      }
    });
  };

  const isLicenseSelected = (id: string) =>
    newlySelectedLicenses.some((l) => l._id === id);


  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.LICENSE,
    drop: (item: any) => {
      setNewlySelectedLicenses((prev) => {
        const isSelected = prev.find((l) => l._id === item.license._id);
        const isAlreadyAssigned = assignedLicenses.find((l) => l._id === item.license._id);
        if (isSelected || isAlreadyAssigned) return prev;
        return [...prev, item.license];
      });
    },

    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const handleAvailableScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (!hasMoreAvailable || isAvailableFetching) return;
    const el = e.currentTarget;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
      setAvailablePage((prev) => prev + 1);
    }
  };

  const handleAssignedScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (!hasMoreAssigned || isAssignedFetching) return;
    const el = e.currentTarget;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
      setAssignedPage((prev) => prev + 1);
    }
  };


  // Sidebar and Layout
  type NavbarSliceState = { isOpen: boolean };
  const isSidebarOpen = useAppSelector(
    (state: RootState) => (state.navbar as NavbarSliceState).isOpen
  );
  const sidebarWidth = isSidebarOpen ? 256 : 64;

  const isNoLicenseModalVisible = useMemo(() => {
    if (isAvailableLoading || isAssignedLoading || isGymLoading || !gymOrgId) return false;

    // Only show if we're viewing "All Licenses" to avoid blocking valid type filtering
    if (licenseType !== "All Licenses") return false;

    return filteredLicenses.length === 0 && selectedLicenses.length === 0 && !hasMoreAvailable && !hasMoreAssigned;
  }, [
    filteredLicenses,
    selectedLicenses,
    isAvailableLoading,
    isAssignedLoading,
    isGymLoading,
    gymOrgId,
    licenseType,
    hasMoreAvailable,
    hasMoreAssigned,
  ]);


  const pageBg = isDark ? "bg-[#0A0A0A]" : "bg-gray-50";
  const cardBg = isDark ? "bg-[#1A1A1A]" : "bg-white";
  const borderColor = isDark ? "border-[#2A2A2A]" : "border-gray-200";

  return (
    <div
      className={`px-4 md:px-6 lg:px-8 pt-20 pb-8 min-h-screen ${pageBg}`}
      style={{
        marginLeft: sidebarWidth,
        width: `calc(100% - ${sidebarWidth}px)`,
        transition: "margin-left 0.3s ease, width 0.3s ease",
      }}
    >
      {/* Breadcrumb - keep outside for consistency with other pages, but move title inside if target image shows it */}
      <div className="mb-6">
        <h1 className={`text-2xl font-bold mb-1 ${isDark ? "text-white" : "text-gray-900"}`}>
          Gyms Overview
        </h1>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Link to="/" className="hover:text-[#B6CB24] transition-colors">
            Dashboard
          </Link>
          <span>/</span>
          <Link
            to={
              isEditMode && gymid
                ? adminRoutes.gymEdit.replace(":gymid", gymid)
                : adminRoutes.gymCreate
            }
            className="hover:text-[#B6CB24] transition-colors"
          >
            {isEditMode ? "Gym Edit" : "Gym Create"}
          </Link>
          <span>/</span>
          <span className="text-[#B6CB24] font-medium">
            {isEditMode ? "Edit Licenses" : "Assign Licenses"}
          </span>
        </div>
      </div>

      <div
        className={`${isDark ? "bg-[#111111] border-[#1F1F1F]" : "bg-white border-gray-200"
          } border rounded-2xl overflow-hidden shadow-2xl`}
      >
        <div className="p-5">
          <div className="mb-4 border-b border-[#1F1F1F]">
            <h1
              className={`text-base font-bold mb-2 ${isDark ? "text-white" : "text-gray-900"
                }`}
            >
              {isEditMode ? "Edit Gym Licenses" : "Create Gym Licenses"}
            </h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Side: Selection */}
            <div className="space-y-6">
              <div>
                <label
                  className={`block text-xs font-semibold mb-3 ${isDark ? "text-gray-100" : "text-gray-700"
                    }`}
                >
                  Choose License Type
                </label>
                <div className="relative">
                  <select
                    value={licenseType}
                    onChange={(e) => setLicenseType(e.target.value)}
                    className={`w-full h-11 px-4 rounded-xl border appearance-none outline-none transition-all text-sm font-medium ${isDark
                      ? "bg-transparent border-[#2A2A2A] text-gray-200 focus:border-[#B6CB24]"
                      : "bg-gray-50 border-gray-200 text-gray-900 focus:border-[#B6CB24]"
                      }`}
                  >
                    <option className="bg-[#111111]">All Licenses</option>
                    <option className="bg-[#111111]">Basic License</option>
                    <option className="bg-[#111111]">Premium License</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div>
                <label
                  className={`block text-xs font-semibold mb-3 ${isDark ? "text-gray-100" : "text-gray-700"
                    }`}
                >
                  Choose License
                </label>
                <div
                  className={`rounded-xl border ${isDark
                    ? "border-[#1F1F1F] bg-[#111111]"
                    : "border-gray-200 bg-gray-50"
                    }`}
                >
                  <div
                    className="h-[360px] overflow-y-auto custom-scrollbar p-6 space-y-3"
                    onScroll={handleAvailableScroll}
                  >
                    {isAvailableLoading || isGymLoading ? (
                      <div className="text-center py-8 text-gray-500">
                        Loading licenses...
                      </div>
                    ) : (filteredLicenses.length === 0 && selectedLicenses.length === 0) ? (

                      <div className="text-center py-8 text-gray-500">
                        {gymOrgId
                          ? "No available licenses found for this organisation."
                          : "No available licenses found."}
                      </div>
                    ) : filteredLicenses.length === 0 ? (
                      null
                    ) : (
                      filteredLicenses.map((license: any) => (
                        <DraggableLicense
                          key={license._id}
                          license={license}
                          isDark={isDark}
                          isSelected={isLicenseSelected(license._id)}
                          toggleLicenseSelection={toggleLicenseSelection}
                        />
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Selected List */}
            <div className="space-y-6">
              <label
                className={`block text-xs font-semibold mb-3 ${isDark ? "text-gray-100" : "text-gray-700"
                  }`}
              >
                Selected Licenses
              </label>
              <div
                ref={drop}
                className={`rounded-2xl border h-[460px] overflow-y-auto custom-scrollbar ${isDark
                  ? "border-[#1F1F1F] bg-[#111111]"
                  : "border-gray-200 bg-gray-50"
                  } p-6 relative transition-colors duration-200 ${isOver ? "bg-[#B6CB24]/5 border-[#B6CB24]" : ""
                  }`}
                onScroll={handleAssignedScroll}

              >
                {selectedLicenses.length === 0 ? (
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 text-center p-8">
                    <div className="w-16 h-16 rounded-3xl bg-gray-500/10 flex items-center justify-center mb-4">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M12 2v20M2 12h20"></path>
                      </svg>
                    </div>
                    <p className="text-sm font-medium">
                      No licenses selected yet
                    </p>
                    <p className="text-xs mt-1 opacity-60">
                      Select or drag from the left panel to add
                    </p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {selectedLicenses.map((license) => (
                      <div
                        key={license._id}
                        className={`group relative p-4 rounded-xl border transition-all duration-300 ${isDark
                          ? "bg-transparent border-[#1F1F1F]"
                          : "bg-white border-gray-200 hover:shadow-md"
                          }`}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div>
                              <LicenseIcon type={license.type} />
                            </div>
                            <div className="flex items-center gap-4 flex-1">
                              <div
                                className={`font-bold text-sm ${isDark ? "text-white" : "text-gray-900"
                                  }`}
                              >
                                {license.type.charAt(0) +
                                  license.type.slice(1).toLowerCase()}
                              </div>
                              <div className="text-[12px] text-gray-400">
                                License ID:{" "}
                                <span className="font-mono text-[#D9FB51] font-bold">
                                  #{license.code || license._id.slice(-6)}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-4">
                            <div className="text-[11px] font-bold">
                              <span className="text-[#D9FB51]">
                                {license.screens?.length || 0}
                              </span>
                              <span
                                className={`${isDark ? "text-gray-400" : "text-gray-500"
                                  } ml-1 mr-3 font-medium`}
                              >
                                Screens +
                              </span>
                              <span className="text-[#D9FB51]">
                                {license.addOnScreens?.length || 0}
                              </span>
                              <span
                                className={`${isDark ? "text-gray-400" : "text-gray-500"
                                  } ml-1 font-medium`}
                              >
                                Addons
                              </span>
                            </div>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                if (license.isAssigned) {
                                  handleStatusChangeClick(
                                    license._id,
                                    license.status || "Active"
                                  );
                                } else {
                                  setNewlySelectedLicenses((prev) =>
                                    prev.filter((l) => l._id !== license._id)
                                  );
                                }
                              }}
                              className="text-gray-400 hover:text-white transition-all"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                              >
                                <path
                                  d="M12.75 0.75L0.75081 12.7492M12.7492 12.75L0.75 0.75085"
                                  stroke="#F3F3F6"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-center pt-6 gap-4 border-t border-[#1F1F1F]">
            <button
              className={`h-10 px-12 rounded-lg font-bold text-black transition-all hover:opacity-90 active:scale-[0.98] disabled:opacity-50 disabled:cursor-wait text-sm ${theme === "dark"
                ? "bg-[#2C2C2C] text-gray-200 hover:bg-[#333333]"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                }`}
              style={{
                background:
                  "radial-gradient(94.17% 100% at 52.48% 0%, #C6D92C 0%, #535B10 100%)",
              }}
              onClick={() => {
                if (noLicensesForOrg) {
                  navigate(adminRoutes.licenses);
                  return;
                }
                handleAssign();
              }}
              disabled={noLicensesForOrg ? false : isAssigning}
            >
              {noLicensesForOrg
                ? "Create License"
                : isAssigning
                  ? isEditMode
                    ? "Updating..."
                    : "Assigning..."
                  : isEditMode
                    ? "Update"
                    : "Create"}
            </button>
            <Link
              to={adminRoutes.gymList}
              className={`h-10 px-12 rounded-lg font-bold border transition-all flex items-center justify-center hover:bg-white/5 text-sm ${isDark
                ? "border-[#2A2A2A] text-gray-400 bg-transparent"
                : "border-gray-200 text-gray-600 bg-gray-50"
                }`}
            >
              Not Now
            </Link>
          </div>
        </div>
      </div>

      <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: ${isDark ? "#333" : "#ddd"};
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #B6CB24;
                }
                `}</style>

      <ConfirmActionModal
        isOpen={confirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
          setLicenseToChange(null);
        }}
        onConfirm={handleConfirmStatusChange}
        title={`Unassign License?`}
        message={`Are you sure you want to unassign this license? This action will affect the gym's access.`}
        confirmText={`Unassign`}
        cancelText="Cancel"
        type="action"
      />

      {/* No Licenses Modal */}
      {isNoLicenseModalVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div
            className={`w-full max-w-md p-6 rounded-2xl shadow-2xl transform transition-all ${isDark ? "bg-[#111111] border border-[#1F1F1F]" : "bg-white"
              }`}
          >
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-[#B6CB24]/10 flex items-center justify-center mx-auto mb-4">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#B6CB24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <h3
                className={`text-xl font-bold mb-2 ${isDark ? "text-white" : "text-gray-900"
                  }`}
              >
                No Licenses Found
              </h3>
              <p
                className={`text-sm mb-8 ${isDark ? "text-gray-400" : "text-gray-500"
                  }`}
              >
                There are no available licenses for this gym&apos;s organization.
                Please create a new license to continue.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={() => navigate(adminRoutes.gymList)}
                  className={`px-6 py-2.5 rounded-xl font-medium transition-colors ${isDark
                    ? "bg-[#1F1F1F] text-gray-300 hover:bg-[#2A2A2A]"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                >
                  Cancel
                </button>
                <button
                  onClick={() => navigate(adminRoutes.licenses)}
                  className="px-6 py-2.5 rounded-xl font-medium bg-[#B6CB24] text-black hover:opacity-90 transition-opacity"
                >
                  Create License
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const GymLicenseSelection: React.FC = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <GymLicenseSelectionContent />
    </DndProvider>
  );
};

export default GymLicenseSelection;
